export default __webpack_public_path__ + "static/media/6-decorated.3379b391.webp";